var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramFormat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75V5.75M17 0.75V5.75M0.75 10.75H23.25M7 15.75H7.0125M12 15.75H12.0125M17 15.75H17.0125M7 20.75H7.0125M12 20.75H12.0125M17 20.75H17.0125M3.25 3.25H20.75C22.1307 3.25 23.25 4.36929 23.25 5.75V23.25C23.25 24.6307 22.1307 25.75 20.75 25.75H3.25C1.86929 25.75 0.75 24.6307 0.75 23.25V5.75C0.75 4.36929 1.86929 3.25 3.25 3.25Z",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFormat);
export default __webpack_public_path__ + "static/media/ProgramFormat.7bb716cddaf2d8a76e0c81d7060d4b01.svg";
export { ForwardRef as ReactComponent };